<template lang="pug">
.auto-detail
  el-form.auto-detail-table(label-position='left', inline='')
    el-form-item(v-for='key in getLayout(layout).layout', :label='prop(key).label', :key='key', v-if='prop(key).$value(data)')
      span(:class='prop(key).$innerClasses(data)') {{ prop(key).$value(data) }}
</template>

<script>
import MixAuto from './mixin'

export default {
  name: 'auto-detail',
  mixins: [MixAuto],
  props: {
    data: { type: Object },
    layout: { type: String, default: 'detail' },
  },
}
</script>



// WEBPACK FOOTER //
// AutoDetail.vue?97fefe3c